var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h6", [_vm._v("■マッチング設定")]),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "個人プロフィール" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "性別",
                  "target-id": _vm.targetIdMap.matching.profile.gender,
                  value: _vm.matching.gender,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.gender
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "年齢",
                  "target-id": _vm.targetIdMap.matching.profile.age,
                  value: _vm.age,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.age
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "現住所",
                  "target-id": _vm.targetIdMap.matching.profile.address,
                  value: _vm.address,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.address
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "最終学歴",
                  "target-id":
                    _vm.targetIdMap.matching.profile.educationalBackground,
                  value: _vm.educationalBackground,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.educationalBackground
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "卒業年月",
                  "target-id": _vm.targetIdMap.matching.profile.graduate,
                  value: _vm.graduate,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.graduate
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "学校名・学部名",
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.matching.profile.educationalSearch.prefix
                  ),
                  "highlight-mode": _vm.highlightMode,
                  "data-test": "educationSearch",
                },
                scopedSlots: _vm._u([
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v(
                            "「学校名」「学部／学科名」から、フリーワード検索をおこないます。（200文字以内）"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "pega-break",
                          attrs: {
                            id: _vm.targetIdMap.matching.profile
                              .educationalSearch.word,
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.matching.educationalSearchWord || "未登録"
                            ),
                          },
                        }),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "pega-break",
                          attrs: {
                            id: _vm.targetIdMap.matching.profile
                              .educationalSearch.label,
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.matching.educationSearchLabel || "未登録"
                            ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "学部・学科コード",
                  "target-id":
                    _vm.targetIdMap.matching.profile.educationDepartment,
                  value: _vm.educationDepartment,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.educationDepartment
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline-sub",
            _vm._g(
              {
                attrs: {
                  title: "現在の就業状況",
                  "target-ids": _vm.targetIdMap.matching.profile.work.list,
                  contents: _vm.work,
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.matching.profile.work.prefix
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "転居を伴う転職可否",
                  "target-id": _vm.targetIdMap.matching.profile.homeMoving,
                  value: _vm.matching.homeMoving,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.homeMoving
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "未既婚",
                  "target-id": _vm.targetIdMap.matching.profile.married,
                  value: _vm.matching.married,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.married
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "子供有無",
                  "target-id": _vm.targetIdMap.matching.profile.child,
                  value: _vm.matching.child,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.child
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "転職回数",
                  "target-id": _vm.targetIdMap.matching.profile.changeJobCount,
                  value: _vm.matching.changeJobCount,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.profile.changeJobCount
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "経験職種・業種" } },
        [
          _c(
            "job-content-table-outline-sub",
            _vm._g(
              {
                attrs: {
                  title: "経験職種",
                  "target-ids":
                    _vm.targetIdMap.matching.experienced.occupation.list,
                  contents: _vm.matching.experiencedOccupationList,
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.matching.experienced.occupation.prefix
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "経験業種",
                  "target-id": _vm.targetIdMap.matching.experienced.business,
                  value: _vm.experiencedBusiness,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.experienced.business
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "語学力" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "TOEIC",
                  "target-id": _vm.targetIdMap.matching.language.toeic,
                  value: _vm.toeic,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.language.toeic
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "TOEFL",
                  "target-id": _vm.targetIdMap.matching.language.toefl,
                  value: _vm.toefl,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.language.toefl
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "英語スキル",
                  "target-id": _vm.targetIdMap.matching.language.english,
                  value: _vm.matching.englishSkill.level,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.language.english
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "英語以外の語学スキル",
                  "target-id": _vm.targetIdMap.matching.language.other,
                  value: _vm.otherLanguage,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.language.other
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "スキルシート・資格" } },
        [
          _vm._l(_vm.skillsMaster, function (skillMaster) {
            return [
              _vm.hasChildCategorySkillBy(skillMaster.id)
                ? [
                    _c(
                      "job-content-table-outline-sub",
                      _vm._g(
                        {
                          key: skillMaster.id,
                          attrs: {
                            title: skillMaster.name,
                            "target-ids":
                              _vm.targetIdMap.matching.skill[skillMaster.id]
                                .list,
                            contents: _vm.skill[skillMaster.id],
                            "comment-highlights": _vm.getAnyCommentHighlights(
                              _vm.targetIdMap.matching.skill[skillMaster.id]
                                .prefix
                            ),
                            "highlight-mode": _vm.highlightMode,
                          },
                        },
                        _vm.$listeners
                      )
                    ),
                  ]
                : [
                    _c(
                      "job-content-table-outline",
                      _vm._g(
                        {
                          key: skillMaster.id,
                          attrs: {
                            title: skillMaster.name,
                            "target-id":
                              _vm.targetIdMap.matching.skill[skillMaster.id],
                            value: _vm.skill[skillMaster.id],
                            "comment-highlights": _vm.getCommentHighlights(
                              _vm.targetIdMap.matching.skill[skillMaster.id]
                            ),
                            "highlight-mode": _vm.highlightMode,
                          },
                        },
                        _vm.$listeners
                      )
                    ),
                  ],
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "保有資格" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "保有資格",
                  "target-id": _vm.targetIdMap.matching.license,
                  value: _vm.license,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.license
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-matching-work-styles",
        _vm._g(
          {
            attrs: {
              matching: _vm.matching,
              "comment-highlights": _vm.getAnyCommentHighlights(
                _vm.targetIdMap.matching.workStyle.prefix
              ),
              "highlight-mode": _vm.highlightMode,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "job-matching-desired",
        _vm._g(
          {
            attrs: {
              matching: _vm.matching,
              "comment-highlights": _vm.getArrayAnyCommentHighlights(
                _vm.prefixes.matchingDesired
              ),
              "highlight-mode": _vm.highlightMode,
            },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }